import React, { FC, useState } from 'react'
import { Stack } from 'components/Stack'
import { LayerGroup as LayerGroupModel } from 'models/layer'
import { LayerGroup } from './components/LayerGroup'
import { GeneratePredictiveModelReportDialog } from './components/GeneratePredictiveModelReportDialog'
import { PreviousPredictiveReports } from './components/PreviousPredictiveReports/PreviousPredictiveReports'
import styles from './Layers.module.scss'
import { useMapEditorContext } from 'context/map-editor-context'


type LayersProps = {
  layers: LayerGroupModel[]
}

export const Layers: FC<LayersProps> = ({ layers }) => {
  const [{ editingLayer }] = useMapEditorContext()
  const [predictiveModelSelected, setPredictiveModelSelected] = useState<string | null>(null)
  const [predictiveModelHistory, setPredictiveModelHistory] = useState<string | null>(null)

  return (
    <div className={styles.layers}>
      <Stack space="medium">
        {layers.map((group) => (
          <LayerGroup
            key={group.name}
            group={group}
            editing={editingLayer}
            selectPredictiveModel={setPredictiveModelSelected}
            selectPredictiveModelHistory={setPredictiveModelHistory}
          />
        ))}
      </Stack>
      <GeneratePredictiveModelReportDialog
        isOpen={!!predictiveModelSelected}
        onClose={() => setPredictiveModelSelected(null)}
        predictiveModelId={predictiveModelSelected!}
      />
      <PreviousPredictiveReports
        isOpen={!!predictiveModelHistory}
        onClose={() => setPredictiveModelHistory(null)}
        predictiveModelId={predictiveModelHistory!}
      />
    </div>
  )
}

Layers.displayName = 'Layers'
